import Tooltip from 'tooltip.js';

$(document).ready(function() {

	$( '[data-tooltip]' ).each(function() {
		new Tooltip($(this), {
			placement: 'top',
			title: $(this).attr('data-tooltip'),
        	trigger: "hover",
		});
	});
});



// WEBPACK FOOTER //
// ./src/js/general/tooltip.js